'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = user;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {};

function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'ORDER_USER_FETCH_SUCCESS':
    case 'ORDER_FETCH_SUCCESS':
      return (0, _extends3.default)({}, state, action.result.user);
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/reducers/user.js
// module id = 2540
// module chunks = 0